import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gold/20 last:border-0" data-id="element-30">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-31">
        <span className="text-lg font-serif text-brown group-hover:text-gold-dark transition-colors pr-8" data-id="element-32">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-gold" data-id="element-33">
          <ChevronDown className="w-5 h-5" data-id="element-34" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-35">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-36">
            <p className="pb-6 text-brown/70 leading-relaxed" data-id="element-37">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Voy a perder mi éxito profesional?',
    answer: 'No, lo vas a sostener desde un lugar de mayor claridad y menos esfuerzo. La suavidad no es debilidad, es eficiencia energética.'
  }, {
    question: '¿Esto es para mujeres casadas?',
    answer: 'Es para toda mujer, esté en pareja o no, que quiera recuperar su polaridad femenina y dejar de operar desde el agotamiento.'
  }, {
    question: '¿Es un libro de religión?',
    answer: 'No, es un manual de psicología aplicada, gestión energética y regulación del sistema nervioso.'
  }, {
    question: '¿Cuánto tiempo me tomará notar cambios?',
    answer: 'Los cambios internos son inmediatos desde el primer ejercicio respiratorio. La transformación externa se hace evidente en los primeros 7 días.'
  }, {
    question: '¿El acceso es inmediato?',
    answer: 'Sí, recibes todo el material digital directamente en tu correo electrónico inmediatamente tras confirmar el pago.'
  }];
  return <section className="py-24 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <FadeIn data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-brown mb-12" data-id="element-41">
            Preguntas Frecuentes
          </h2>

          <div className="bg-cream/50 rounded-3xl p-6 md:p-10 border border-gold/10" data-id="element-42">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}